import { NavButton } from 'Components/ClientApp/CombinedApp/Navigation/NavButton';
import React from 'react';
import { clientPaths } from 'Consts/Strings';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import fr from 'facet-rest';
import { buildPageLink } from 'Views/Page/Content/Templates';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import categories from 'EventTracking/consts/categories';
import eventTypes from 'EventTracking/consts/eventTypes';
import eventSubTypes from 'EventTracking/consts/eventSubTypes';

export const FoundationsNavButton = () => {
  const { householdResource } = useSimpleHousehold();
  const { logStandardizedEvent } = useEventTrackingLogEvent();


  const dropdownItems = [
    householdResource.withRelationship(
      fr.relationships.planPage.name,
      (rel) => ({
        key: 'plan',
        primaryText: rel.meta('prompt'),
        to: buildPageLink(rel.link('related'), clientPaths.planPage),
        onClick: () => {
          logStandardizedEvent(categories.foundations, eventTypes.click, eventSubTypes.navBarItem, {
            eventProperties: {
              navBarItem: rel.meta('prompt'),
            },
          });
        },
      }),
      () => null,
    ),
    householdResource.withRelationship(
      fr.relationships.cashFlowPage.name,
      (rel) => ({
        key: 'cashFlow',
        primaryText: rel.meta('prompt'),
        to: buildPageLink(rel.link('related'), clientPaths.cashFlowPage),
        onClick: () => {
          logStandardizedEvent(categories.foundations, eventTypes.click, eventSubTypes.navBarItem, {
            eventProperties: {
              navBarItem: 'Cash Flow',
            },
          });
        },
      }),
      () => null,
    ),
    householdResource.withRelationship(
      fr.relationships.householdBalanceSheetPage.name,
      (rel) => ({
        key: 'balanceSheet',
        primaryText: rel.meta('prompt'),
        to: buildPageLink(rel.link('related'), clientPaths.balanceSheet),
        onClick: () => {
          logStandardizedEvent(categories.foundations, eventTypes.click, eventSubTypes.navBarItem, {
            eventProperties: {
              navBarItem: rel.meta('prompt'),
            },
          });
        },
      }),
      () => null,
    ),
  ];

  return (
    <NavButton
      value="foundations"
      label="Foundations"
      isDropdown
      dropdownItems={dropdownItems.filter(Boolean)}
    />
  );
};
